const rootConst = 'RIDER';

export const VALIDATE_ORDER = `${rootConst}/VALIDATE_ORDER`;
export const VALIDATE_OTP = `${rootConst}/VALIDATE_OTP`;
export const GET_ORDER_DETAILS = `${rootConst}/GET_ORDER_DETAILS`;

export const CONFIRM_ORDER = `${rootConst}/CONFIRM_ORDER`;
export const DELIVERED_ORDER = `${rootConst}/DELIVERED_ORDER`;
